import { createApp } from 'vue'
import App from './App.vue'
import config from './config.json'

// Merge two objects deeply
const mergeDeep = (target, source) => {
    for (const key in source) {
        if (source[key] instanceof Object && key in target) {
            Object.assign(source[key], mergeDeep(target[key], source[key]));
        }
    }
    Object.assign(target || {}, source);
    return target;
};

// Get all instances of divs with id "app"
const appContainerList = document.querySelectorAll("#app");

// Select all instances of divs with id "app"
appContainerList.forEach((appContainer) => {
    let wpConfig = {};

    // Parse attributes from the data-attributes attribute
    try {
        wpConfig = JSON.parse(appContainer.dataset.attributes);
        // console.log('wpConfig', wpConfig);
    } catch (e) {
        console.warn('Error parsing config provided by Wordpress, using default values');
    }

    // Merge worpress config with default config (default is overwritten)
    config = mergeDeep(config, wpConfig);
    // console.log('config', config);
    
    // Create a new Vue instance for each container
    const app = createApp(App);

    // Provide attributes as global properties
    app.provide('config', config);

    app.mount(appContainer);
});